import { useState } from "react";
import {
  legacyCallingNumbers,
  legacyPushResultOffices,
  type LegacyCallingNumber,
} from "../../mock/legacySms";
import "./LegacyCallingNumber.css";

export function LegacyCallingNumber() {
  const [office, setOffice] = useState<string>(legacyPushResultOffices[0]);
  const [numbers, setNumbers] = useState(legacyCallingNumbers);
  const [notice, setNotice] = useState<string | null>(null);
  const changeOffice = (value: string) => {
    setOffice(value);
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?office_id=${value === legacyPushResultOffices[0] ? "mock-office-01" : "mock-office-02"}`,
    );
  };
  const open = (path: string) =>
    window.open(path, "_blank", "popup=yes,width=430,height=500");
  const remove = (id: string) => {
    setNumbers((items) => items.filter((item) => item.id !== id));
    setNotice(
      "Mock 발신번호가 삭제되었습니다. 실제 설정은 변경되지 않았습니다.",
    );
  };
  return (
    <div className="legacy-m08 g_content_wrap">
      <h1 className="g_title">문자 발신 번호 관리</h1>
      <aside className="g_filter_wrap">
        <div className="g_input_wrap">
          <label className="g_label title center">지점</label>
          <select
            id="office_select"
            className="g_input width_2x"
            value={office}
            onChange={(event) => changeOffice(event.target.value)}
          >
            {legacyPushResultOffices.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </div>
      </aside>
      <div className="g_btn_wrap right">
        <button
          id="l_add_btn"
          className="g_btn add"
          type="button"
          onClick={() =>
            open(
              "/callingnumber_registration/?CRUD=1&caller=calling&office_id=mock-office-01",
            )
          }
        >
          발신번호추가
        </button>
      </div>
      <div className="g_list_wrap">
        <table className="g_list calling_phone_table">
          <colgroup>
            <col style={{ width: 64.28125 }} />
            <col style={{ width: 122.484375 }} />
            <col style={{ width: 225.890625 }} />
            <col style={{ width: 274.890625 }} />
            <col style={{ width: 155.703125 }} />
            <col style={{ width: 155.75 }} />
          </colgroup>
          <thead>
            <tr>
              {[
                "No",
                "지점이름",
                "발신번호",
                "발신번호이름",
                "수정",
                "삭제",
              ].map((item) => (
                <th key={item}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {numbers.map((item, index) => (
              <CallingRow
                key={item.id}
                item={item}
                index={index}
                onEdit={() =>
                  open(
                    `/callingnumber_update/${item.id}/?CRUD=3&detail_id=${item.id}&office_id=mock-office-01&caller=calling`,
                  )
                }
                onDelete={() => remove(item.id)}
              />
            ))}
          </tbody>
        </table>
      </div>
      {notice && (
        <div className="m08-notice">
          {notice}
          <button type="button" onClick={() => setNotice(null)}>
            ×
          </button>
        </div>
      )}
    </div>
  );
}

function CallingRow({
  item,
  index,
  onEdit,
  onDelete,
}: {
  item: LegacyCallingNumber;
  index: number;
  onEdit: () => void;
  onDelete: () => void;
}) {
  return (
    <tr>
      <td>{index + 1}</td>
      <td>{item.office}</td>
      <td>{item.phone}</td>
      <td>{item.name}</td>
      <td>
        <button className="g_btn save" type="button" onClick={onEdit}>
          수정
        </button>
      </td>
      <td>
        <button className="g_btn delete" type="button" onClick={onDelete}>
          삭제
        </button>
      </td>
    </tr>
  );
}

export function LegacyCallingNumberForm({ mode }: { mode: "add" | "update" }) {
  const [phone, setPhone] = useState(mode === "update" ? "010-0000-0001" : "");
  const [name, setName] = useState(mode === "update" ? "Mock 발신번호 1" : "");
  const [notice, setNotice] = useState<string | null>(null);
  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!phone || !name) {
      setNotice("Mock 발신번호와 이름을 입력해 주세요.");
      return;
    }
    setNotice(
      `Mock 발신번호가 ${mode === "add" ? "등록" : "수정"}되었습니다. 실제 설정은 변경되지 않았습니다.`,
    );
  };
  return (
    <main className="legacy-m08-popup">
      <div className="g_title">발신번호 {mode === "add" ? "등록" : "수정"}</div>
      <form id="numberlist_form" onSubmit={submit}>
        <div className="g_row">
          <div className="g_input_wrap">
            <label className="g_label title l_title_width">발신번호</label>
            <input
              className="g_input"
              value={phone}
              maxLength={13}
              onChange={(event) =>
                setPhone(event.target.value.replace(/[^0-9-]/g, ""))
              }
            />
          </div>
        </div>
        <div className="g_row">
          <div className="g_input_wrap">
            <label className="g_label title l_title_width">발신번호이름</label>
            <input
              className="g_input width_2x"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </div>
        </div>
        <div className="margin_top_10">
          <button
            className={`g_btn ${mode === "add" ? "save" : "modify"}`}
            type="submit"
          >
            {mode === "add" ? "등록" : "수정"}
          </button>
        </div>
      </form>
      {notice && (
        <div className="m08-notice">
          {notice}
          <button type="button" onClick={() => setNotice(null)}>
            ×
          </button>
        </div>
      )}
    </main>
  );
}
